// import { Box, styled } from "@mui/material";
// import FlexBox from "components/flexbox/FlexBox";
// import Scrollbar from "components/ScrollBar";
// import LayoutDrawer from "layouts/layout-parts/LayoutDrawer";
// import MultiLevelMenu from "./MultiLevelMenu";
// const TOP_HEADER_AREA = 70;
// const NavWrapper = styled(Box)(() => ({
//   paddingLeft: 16,
//   paddingRight: 16,
//   height: "100%"
// }));
// const StyledLogo = styled(Box)(() => ({
//   paddingLeft: 8,
//   fontWeight: 700,
//   fontSize: 20
// }));

// const MobileSidebar = props => {
//   const {
//     sidebarCompact,
//     showMobileSideBar,
//     setShowMobileSideBar
//   } = props;
//   return <LayoutDrawer open={showMobileSideBar} onClose={setShowMobileSideBar}>
//       <Box p={2} maxHeight={TOP_HEADER_AREA}>
//         <FlexBox ml={1.5}>
//           <img src="/static/logo/logo.svg" alt="logo" width={18} />
//           <StyledLogo>UO</StyledLogo>
//         </FlexBox>
//       </Box>

//       <Scrollbar autoHide clickOnTrack={false} sx={{
//       overflowX: "hidden",
//       maxHeight: `calc(100vh - ${TOP_HEADER_AREA}px)`
//     }}>
//         <NavWrapper compact={sidebarCompact}>
//           <MultiLevelMenu sidebarCompact={false} />
//         </NavWrapper>
//       </Scrollbar>
//     </LayoutDrawer>;
// };

// export default MobileSidebar;

import { Box, styled } from "@mui/material";
import FlexBox from "components/flexbox/FlexBox";
import Scrollbar from "components/ScrollBar";
import LayoutDrawer from "layouts/layout-parts/LayoutDrawer";
import MultiLevelMenu from "./MultiLevelMenu";
import FlexBetween from "components/flexbox/FlexBetween";

const TOP_HEADER_AREA = 70;

const NavWrapper = styled(Box)(() => ({
  paddingLeft: 16,
  paddingRight: 16,
  height: "100%",
}));

const StyledLogo = styled(Box)(() => ({
  paddingLeft: 8,
  fontWeight: 700,
  fontSize: 20,
}));

const SidebarWrapper = styled(Box)(({
  theme,
  compact
}) => ({
  height: "100vh",
  position: "fixed",
  width: compact ? 86 : 280,
  transition: "all .2s ease",
  zIndex: theme.zIndex.drawer,
  backgroundColor: theme.palette.background.paper,
  "&:hover": compact && {
    width: 280
  }
}));
const MobileSidebar = ({ showMobileSideBar, setShowMobileSideBar }) => {
  return (
    <LayoutDrawer open={showMobileSideBar} onClose={setShowMobileSideBar}>
      {/* HEADER: LOGO */}
<SidebarWrapper>
  {/* HEADER: LOGO */}
  <FlexBetween
    pt={2}
    pr={3}
    pl={3}
    pb={1}
    height={TOP_HEADER_AREA}
  >
    <FlexBox alignItems="center" gap={1}>
      <img
        src="/nextgen/nextgen_logo.png"
        alt="NextGen Logo"
        style={{ height: 40, maxWidth: 160, objectFit: "contain" }}
      />
      {/* <Box sx={{ fontWeight: 700, fontSize: 20, pl: 1 }}>
        NextGen
      </Box> */}
    </FlexBox>
  </FlexBetween>

  {/* NAVIGATION ITEMS */}
  <Scrollbar
    autoHide
    clickOnTrack={false}
    sx={{
      overflowX: "hidden",
      maxHeight: `calc(100vh - ${TOP_HEADER_AREA}px)`,
    }}
  >
    <NavWrapper>
      <MultiLevelMenu sidebarCompact={false} />
    </NavWrapper>
  </Scrollbar>
</SidebarWrapper>

    </LayoutDrawer>
  );
};

export default MobileSidebar;
